var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-screen -helper--flex align-center",class:this.userMessageContext.popupAlignmentClass ? this.userMessageContext.popupAlignmentClass : 'justify-center',on:{"click":_vm.handleClick}},[_c(_vm.activePopup,{tag:"component",attrs:{"popupProps":_vm.popupTypeProps}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84e87d04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/userMessage/UserMessage.vue
// module id = null
// module chunks = 